<div class="flex flex-col justify-center items-center">
    <div class="w-full p-8 text-center text-4xl text-black dark:text-white font-semibold">Ancora non siamo pronti per
        questo
        servizio!</div>
    <div class="w-full p-8 text-center text-2xl text-black dark:text-white font-semibold">Torna a trovarci tra un po'...
    </div>
    <img src="assets/work-in-progress.svg" class="h-100 w-auto object-contain">
</div>